import {
  faChevronLeft,
  faChevronRight,
  faChevronsLeftSolid,
  faChevronsRightSolid,
  faObjectGroupSolid,
  FaIcon,
} from '@/lib/fa'
import * as React from 'react'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const WeeklyNavigation = ({
  goToPreviousBlock,
  goToNextBlock,
  isLoading,
  wrapperRef,
  prevButtonRef,
  nextButtonRef,
  currentDateRange,
  rangeMode,
  onToggleRangeMode,
}: {
  goToPreviousBlock: () => void
  goToNextBlock: () => void
  isLoading: boolean
  wrapperRef: React.RefObject<HTMLDivElement>
  prevButtonRef: React.RefObject<HTMLButtonElement>
  nextButtonRef: React.RefObject<HTMLButtonElement>
  currentDateRange: string
  rangeMode: boolean
  onToggleRangeMode: () => void
}) => {
  const { t } = useLocalize()
  const scrollAccumulatorRef = React.useRef(0)
  const SCROLL_THRESHOLD = 50

  React.useEffect(() => {
    const handleWheel = (e: WheelEvent) => {
      e.preventDefault()

      scrollAccumulatorRef.current += e.deltaY

      if (scrollAccumulatorRef.current >= SCROLL_THRESHOLD) {
        nextButtonRef.current?.click()
        scrollAccumulatorRef.current = 0
      } else if (scrollAccumulatorRef.current <= -SCROLL_THRESHOLD) {
        prevButtonRef.current?.click()
        scrollAccumulatorRef.current = 0
      }
    }

    const wrapper = wrapperRef.current
    if (wrapper) {
      wrapper.addEventListener('wheel', handleWheel, { passive: false })
    }

    return () => {
      if (wrapper) {
        wrapper.removeEventListener('wheel', handleWheel)
      }
    }
  }, [wrapperRef, prevButtonRef, nextButtonRef])

  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-bg-white tw-px-5 tw-py-3">
      <div className="tw-flex tw-items-center tw-gap-1">
        <button
          onClick={goToPreviousBlock}
          className="tw-grid tw-h-6 tw-w-6 tw-cursor-pointer tw-place-items-center tw-rounded-full tw-border tw-border-base-300 tw-bg-white"
        >
          <FaIcon icon={faChevronsLeftSolid} className="tw-h-[10px]" />
        </button>
        <button
          className="tw-grid tw-h-6 tw-w-6 tw-cursor-pointer tw-place-items-center tw-rounded-full tw-border tw-border-base-300 tw-bg-white"
          ref={prevButtonRef}
          onClick={goToPreviousBlock}
          disabled={isLoading}
        >
          <FaIcon icon={faChevronLeft} className="tw-h-[10px]" />
        </button>
        <p className="tw-px-2 tw-text-base tw-font-semibold tw-text-content-base">
          {currentDateRange}
        </p>
        <button
          className="tw-grid tw-h-6 tw-w-6 tw-cursor-pointer tw-place-items-center tw-rounded-full tw-border tw-border-base-300 tw-bg-white"
          ref={nextButtonRef}
          onClick={goToNextBlock}
          disabled={isLoading}
        >
          <FaIcon icon={faChevronRight} className="tw-h-[10px]" />
        </button>
        <button
          onClick={goToNextBlock}
          className="tw-grid tw-h-6 tw-w-6 tw-cursor-pointer tw-place-items-center tw-rounded-full tw-border tw-border-base-300 tw-bg-white"
        >
          <FaIcon icon={faChevronsRightSolid} className="tw-h-[10px]" />
        </button>
      </div>
      <div className="tw-flex tw-items-center tw-gap-2">
        <button
          onClick={onToggleRangeMode}
          title={t('driverModule.range-selection')}
          className={`tw-flex tw-h-7 tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded tw-border tw-px-3 tw-text-xs tw-font-semibold tw-transition-colors ${
            rangeMode
              ? 'tw-border-primary tw-bg-primary tw-text-white'
              : 'tw-border-base-300 tw-bg-white tw-text-content-base hover:tw-bg-base-100'
          }`}
        >
          <FaIcon icon={faObjectGroupSolid} className="tw-h-[12px]" />
          <span>{t('driverModule.range-selection')}</span>
        </button>
      </div>
    </div>
  )
}

export default WeeklyNavigation
